import Compressor from 'compressorjs';

export const promiseCompressor = (file) => {
	return new Promise((resolve, reject) => {
		new Compressor(file, {
			quality: 0.6,
			success(result) {
				resolve(result);
			},
			error(error) {
				reject(error);
			},
		});
	});
};
